export default {
  container: "tagsel-inner-container",
  containerOpen: "tagsel-inner-container--open",
  input: "oui-tagsel-input",
  inputOpen: "oui-tagsel-input--open",
  inputFocused: "oui-tagsel-input--focused",
  itemsContainer: "oui-tagsel-items-container",
  itemsContainerOpen: "oui-tagsel-items-container--open",
  itemsList: "oui-tagsel-items-list",
  item: "oui-tagsel-item",
  itemFirst: "oui-tagsel-item--first",
  itemHighlighted: "oui-tagsel-item--highlighted"
};
